import { Button, TextLink } from '@petsmart-ui/sparky';
import type { MouseEvent } from 'react';

import { useAuthSignInClick, useCart, useLogout, useUserSession } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';

type AccountActionProps = {
    onLinkSelect: () => void;
};

export function AccountAction({ onLinkSelect }: Readonly<AccountActionProps>) {
    const { user, userData } = useUserSession();
    const { isAuth0Enabled, handleSignInClick } = useAuthSignInClick();
    const { clearCart } = useCart();
    const logout = useLogout();
    const userName = user?.gn?.trim() || userData?.profile?.firstName?.trim() || '';

    const handleSignOut = async () => {
        onLinkSelect();
        await logout({ redirectUrl: '/sign-in', callback: clearCart, forceRedirect: true });
    };

    function handleGuestAccountClick(event: MouseEvent<HTMLAnchorElement>) {
        onLinkSelect();

        if (isAuth0Enabled) {
            event.preventDefault();
            handleSignInClick();
        }
    }

    if (!user) {
        return (
            <TextLink
                href={NAVIGATION_URLS.velocity.signIn}
                className="mobile-menu-quick-links__link mobile-menu-quick-links__link--account"
                onClick={handleGuestAccountClick}
            >
                Sign in or create account
            </TextLink>
        );
    }

    return (
        <div className="mobile-menu-quick-links__link">
            {userName && <span>Not {userName}? </span>}
            <Button
                className="mobile-menu-quick-links__sign-out"
                text="Sign out"
                type="button"
                variant="link"
                onClick={handleSignOut}
            />
        </div>
    );
}
